angular.module('impactx.product').controller('ProductEuelCtrl', [
    '$scope',
    '$mdDialog',
    'TranslationService',
    ProductEuelCtrl
]);

function ProductEuelCtrl($scope, $mdDialog, TranslationService) {
    this.energyEfficiencyLabel = TranslationService.get("energyEfficiencyLabel");
    this.productDataSheet = TranslationService.get("productDataSheet");
    this.cancel = function () {
        $mdDialog.cancel();
    }

}